"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authService = exports.AuthService = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var auth0_spa_js_1 = require("@auth0/auth0-spa-js");
var customerProfile_service_1 = require("../utils/customerProfile-service");
var location_service_1 = require("../utils/location-service");
var rxjs_2 = require("rxjs");
var jwt_services_1 = require("../jwt-service/jwt-services");
var parseHash_service_1 = require("../utils/parseHash-service");
var tokenVerifier_service_1 = require("../utils/tokenVerifier-service");
var parseHash_model_1 = require("../../model/parseHash-model");
var session_storage_keys_model_1 = require("../../model/session-storage-keys.model");
var AuthService = /** @class */ (function () {
    function AuthService() {
        var _this = this;
        this.loggedIn$ = new rxjs_2.BehaviorSubject(false);
        this.user$ = new rxjs_2.BehaviorSubject(null);
        this.mobileAuthModeInitialised = false;
        this.getAuth0Client = function () {
            return _this.authClient;
        };
        this.getAuth0Client$ = function () {
            if (_this.authClient && _this.authConfiguration.authConfig) {
                return (0, rxjs_1.of)(_this.authClient);
            }
            _this.authClient = _this.createClient();
            return (0, rxjs_1.from)(_this.getToken(_this.authClient, _this.authConfiguration.authConfig)).pipe((0, operators_1.concatMap)(function (accessToken) {
                return _this.setUser(_this.authClient, accessToken, _this.authConfiguration.authConfig).pipe((0, operators_1.map)(function () {
                    return _this.authClient;
                }));
            }), (0, operators_1.catchError)(function (err) { return (0, rxjs_1.throwError)(err); }));
        };
    }
    Object.defineProperty(AuthService, "Instance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: false,
        configurable: true
    });
    AuthService.prototype.resetInstance = function () {
        this.clearUserAccessToken();
        this.setMobileAuthMode(false);
        this.initialised = false;
        this.authClient = null;
        this.authConfiguration = null;
    };
    AuthService.prototype.getAuthConfiguration = function () {
        return this.authConfiguration;
    };
    AuthService.prototype.isLoggedIn = function () {
        return this.loggedIn$.getValue();
    };
    AuthService.prototype.isLoggedIn$ = function () {
        return this.loggedIn$;
    };
    AuthService.prototype.getAuthenticatedUser = function () {
        return this.user$.getValue();
    };
    AuthService.prototype.getAuthenticatedUser$ = function () {
        return this.user$;
    };
    AuthService.prototype.initialise = function (configuration, mobileHash) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var hashFlowInitialised, checkAuth$;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.authConfiguration = configuration;
                        if (!this.initialised) {
                            this.initialised = true;
                        }
                        else {
                            return [2 /*return*/, Promise.resolve(this.isLoggedIn())];
                        }
                        if (!((_a = configuration.mobileHashAuthFlow) === null || _a === void 0 ? void 0 : _a.allowed)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initialiseMobileHashAuthFlow(configuration, mobileHash)];
                    case 1:
                        hashFlowInitialised = _b.sent();
                        if (hashFlowInitialised === parseHash_model_1.InitialisedHashFlowStatus.Success) {
                            return [2 /*return*/, Promise.resolve(true)];
                        }
                        if (configuration.mobileHashAuthFlow.onlyFormOfAuth) {
                            return [2 /*return*/, Promise.reject('Error with authentication')];
                        }
                        _b.label = 2;
                    case 2:
                        checkAuth$ = this.getAuth0Client$();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                checkAuth$.pipe((0, operators_1.take)(1)).subscribe(function () {
                                    var urlParams = new URLSearchParams(location.search);
                                    var isReturningFromLoginPage = urlParams.get('code') && urlParams.get('state');
                                    if (isReturningFromLoginPage) {
                                        urlParams.delete('code');
                                        urlParams.delete('state');
                                    }
                                    history.replaceState(null, '', '?' + urlParams + location.hash);
                                    resolve(_this.isLoggedIn());
                                }, function (error) {
                                    reject(error);
                                });
                            })];
                }
            });
        });
    };
    AuthService.prototype.login = function (redirect_uri) {
        var _this = this;
        var _a;
        if (redirect_uri === void 0) { redirect_uri = ''; }
        redirect_uri = redirect_uri.replace('#//', '#/');
        var successCallbackUrl = location_service_1.locationService.appendCurrentQueryStringsToUrl(redirect_uri === '' ? this.authConfiguration.authConfig.redirect_uri : redirect_uri);
        if (this.authConfiguration.preLoginRedirectCallback) {
            this.authConfiguration.preLoginRedirectCallback(successCallbackUrl);
        }
        var loginRedirect = (0, rxjs_1.from)(this.authConfiguration.isSamlLoginRequired && ((_a = this.authConfiguration.authConfig) === null || _a === void 0 ? void 0 : _a.saml_login_url)
            ? this.authConfiguration.isSamlLoginRequired()
            : Promise.resolve(false)).pipe((0, operators_1.first)(), (0, operators_1.switchMap)(function (isSamlEnabled) {
            var _a;
            if (isSamlEnabled) {
                return (0, rxjs_1.from)((_a = _this.authConfiguration.authConfig) === null || _a === void 0 ? void 0 : _a.saml_login_url).pipe((0, operators_1.first)(), (0, operators_1.concatMap)(function (samlLoginURL) {
                    window.location.href = samlLoginURL;
                    return (0, rxjs_1.of)(null);
                }));
            }
            else {
                return _this.getAuth0Client$().pipe((0, operators_1.first)(), (0, operators_1.concatMap)(function (client) {
                    return (0, rxjs_1.from)(client.loginWithRedirect({
                        redirect_uri: successCallbackUrl,
                    }));
                }));
            }
        }));
        this.loginSubscription = loginRedirect.subscribe();
        return loginRedirect;
    };
    AuthService.prototype.getAccessTokenFromStorage = function () {
        var tokenIsExpired = jwt_services_1.jwtService.isAccessTokenExpired();
        return tokenIsExpired ? null : jwt_services_1.jwtService.getAccessToken();
    };
    AuthService.prototype.getApiAuthToken = function () {
        if (this.getMobileAuthMode()) {
            return Promise.resolve(this.getAccessTokenFromStorage());
        }
        if (this.isLoggedIn()) {
            return this.getToken(this.authClient, this.authConfiguration.authConfig);
        }
        return Promise.resolve(null);
    };
    AuthService.prototype.logout = function (returnRoute) {
        return __awaiter(this, void 0, void 0, function () {
            var successCallbackUrl;
            var _this = this;
            return __generator(this, function (_a) {
                successCallbackUrl = location_service_1.locationService.appendCurrentQueryStringsToUrl(returnRoute ? this.authConfiguration.authConfig.redirect_uri + returnRoute : '/');
                return [2 /*return*/, new Promise(function (resolve) {
                        // Ensure Auth0 client instance exists
                        _this.getAuth0Client$()
                            .pipe((0, operators_1.take)(1))
                            .subscribe(function (client) {
                            _this.clearUserAccessToken();
                            _this.setMobileAuthMode(false);
                            client.logout({
                                client_id: _this.authConfiguration.authConfig.client_id,
                                returnTo: successCallbackUrl,
                            });
                            _this.authClient = null;
                            resolve();
                        });
                    })];
            });
        });
    };
    AuthService.prototype.initialiseMobileHashAuthFlow = function (configuration, mobileHash) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, hash, platform, verifier, hashService, state, payload, error_1, accessTokenFromStorage, idTokenFromStorage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = (0, parseHash_service_1.convertHashFromMobileAppLink)(mobileHash), hash = _a.hash, platform = _a.platform;
                        verifier = new tokenVerifier_service_1.TokenVerifierService(configuration.authConfig, platform);
                        hashService = new parseHash_service_1.ParseHashService(verifier);
                        state = 's';
                        if (!hash) return [3 /*break*/, 5];
                        payload = void 0;
                        history.replaceState('', document.title, window.location.pathname + window.location.search + '#/');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, hashService.parseHashFromMobileAsync({ hash: hash, state: state })];
                    case 2:
                        payload = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        return [2 /*return*/, Promise.resolve(parseHash_model_1.InitialisedHashFlowStatus.Error)];
                    case 4:
                        this.setMobileAuthMode(true);
                        jwt_services_1.jwtService.setAccessToken(payload.accessToken);
                        jwt_services_1.jwtService.setIdToken(payload.idToken);
                        this.setPartialUserFromIdToken(payload.idToken);
                        this.isLoggedIn$().next(true);
                        return [2 /*return*/, Promise.resolve(parseHash_model_1.InitialisedHashFlowStatus.Success)];
                    case 5:
                        if (this.getMobileAuthMode()) {
                            accessTokenFromStorage = this.getAccessTokenFromStorage();
                            if (accessTokenFromStorage) {
                                idTokenFromStorage = jwt_services_1.jwtService.getIdToken();
                                this.setPartialUserFromIdToken(idTokenFromStorage);
                                this.isLoggedIn$().next(true);
                                return [2 /*return*/, Promise.resolve(parseHash_model_1.InitialisedHashFlowStatus.Success)];
                            }
                        }
                        return [2 /*return*/, Promise.resolve(parseHash_model_1.InitialisedHashFlowStatus.Error)];
                }
            });
        });
    };
    AuthService.prototype.createClient = function () {
        var _a;
        if (this.authConfiguration.customAuth0Client) {
            return (_a = this.authConfiguration) === null || _a === void 0 ? void 0 : _a.customAuth0Client();
        }
        var client = new auth0_spa_js_1.Auth0Client({
            domain: this.authConfiguration.authConfig.domain,
            client_id: this.authConfiguration.authConfig.client_id,
            redirect_uri: this.authConfiguration.authConfig.redirect_uri,
            scope: this.authConfiguration.auth0Scope ? this.authConfiguration.auth0Scope : 'openid profile email',
        });
        return client;
    };
    AuthService.prototype.getToken = function (client, config) {
        var _this = this;
        return client
            .getTokenSilently({ audience: config.audience })
            .catch(function () {
            sessionStorage.removeItem(session_storage_keys_model_1.SessionStorageKeys.AccessToken);
            sessionStorage.removeItem(session_storage_keys_model_1.SessionStorageKeys.IdToken);
            return null;
        })
            .then(function (accessToken) {
            if (accessToken) {
                jwt_services_1.jwtService.setAccessToken(accessToken);
            }
            else {
                _this.clearUserAccessToken();
            }
            return accessToken;
        });
    };
    AuthService.prototype.setUser = function (client, accessToken, config) {
        var _this = this;
        if (!accessToken) {
            var customerProfile = customerProfile_service_1.customerProfileService.getCustomerProfile();
            customerProfile.isNewCustomer = true;
            customerProfile_service_1.customerProfileService.setCustomerProfile(customerProfile);
            return (0, rxjs_1.of)(null);
        }
        return (0, rxjs_1.from)(client.getUser({ audience: config.audience })).pipe((0, operators_1.concatMap)(function (user) {
            var customerProfile = customerProfile_service_1.customerProfileService.getCustomerProfile();
            customerProfile.isNewCustomer = false;
            customerProfile_service_1.customerProfileService.setCustomerProfile(customerProfile);
            _this.updateLoggedIn(!!accessToken, user);
            return (0, rxjs_1.from)(_this.authConfiguration.loginSuccesfulCallback
                ? _this.authConfiguration.loginSuccesfulCallback(user).then(function () { return user; })
                : Promise.resolve(user));
        }));
    };
    AuthService.prototype.setPartialUserFromIdToken = function (idToken) {
        var partialUser = this.getPartialUserFromIdToken(idToken);
        this.user$.next(partialUser);
        this.loggedIn$.next(true);
    };
    AuthService.prototype.getPartialUserFromIdToken = function (idToken) {
        var userNameDetails = jwt_services_1.jwtService.getUserNameFromToken(idToken);
        return {
            name: userNameDetails.fullName,
            family_name: userNameDetails.lastName,
            given_name: userNameDetails.firstName,
        };
    };
    AuthService.prototype.clearUserAccessToken = function () {
        var _a;
        sessionStorage.removeItem('a0.spajs.txs');
        sessionStorage.removeItem(session_storage_keys_model_1.SessionStorageKeys.AccessToken);
        sessionStorage.removeItem(session_storage_keys_model_1.SessionStorageKeys.IdToken);
        if ((_a = this.authConfiguration) === null || _a === void 0 ? void 0 : _a.preLogoutCallback) {
            this.authConfiguration.preLogoutCallback();
        }
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
            this.loginSubscription = null;
        }
        this.updateLoggedIn(false, null);
    };
    AuthService.prototype.updateLoggedIn = function (loggedIn, user) {
        this.loggedIn$.next(loggedIn);
        this.user$.next(user);
    };
    AuthService.prototype.getMobileAuthMode = function () {
        return sessionStorage.getItem(session_storage_keys_model_1.SessionStorageKeys.AuthMode) === 'mobile';
    };
    AuthService.prototype.setMobileAuthMode = function (mobileMode) {
        if (mobileMode) {
            sessionStorage.setItem(session_storage_keys_model_1.SessionStorageKeys.AuthMode, 'mobile');
        }
        else {
            sessionStorage.removeItem(session_storage_keys_model_1.SessionStorageKeys.AuthMode);
        }
    };
    return AuthService;
}());
exports.AuthService = AuthService;
exports.authService = AuthService.Instance;
